/* istanbul ignore file */
/** This is a placeholder, not real render in dom */
const TreeNode = () => null;
TreeNode.inheritAttrs = false;
TreeNode.displayName = 'ATreeSelectNode';
TreeNode.isTreeSelectNode = true;
export default TreeNode;